// extracted by mini-css-extract-plugin
export default {"itemsContainer":"RoutesBar_itemsContainer__itgA1"};